import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import Slider from '../layouts/slider.js'

import Collapse, { Panel } from "rc-collapse";

import india_character from '../img/subdomen/india_character_home.svg'

import review_logo from '../img/review-logo.svg'
import trustpilot from '../img/trustpilot-logo.svg'
import current_projects from '../img/current-projects.svg'
import register_now from '../img/register-now.svg'

import ogp_cover from '../img/cover.png'

export default class Index extends React.Component {

	constructor() {
		super();

		this.state = { 
			average: '',
			averageOrders: '',
			totalNumberOfReviews: '',
			trustScore: '',
			currentRatingWord:'',
			ratingWord: '',
			ratingListWord: [ 
				"Bad",
				"Poor",
				"Average",
				"Great",
				"Excellent"
			]
		}

	}

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
		const self = this;
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);

		if(!document.getElementById('available_total')) {
			window.logIt = function(data) {
				self.setState({average: data.avg});
				self.setState({averageOrders: data.count});
			}.bind(self);
			 
			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = process.env.GATSBY_API_URL+'/api/orders/available/total?callback=logIt&jsonp=true';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'available_total'));
		}

		if(!document.getElementById('trustpilot_widget')) {
			window.trustpilot = function(data) {
				self.setState({totalNumberOfReviews: data.ratingsTotalCount});
				self.setState({trustScore: data.trustScore});

				self.setState({currentRatingWord: Math.ceil((data.trustScore * 5) / 5)});
				self.setState({ratingWord: self.state.ratingListWord[self.state.currentRatingWord-1]});
			}.bind(self);
			 
			(function (d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = process.env.GATSBY_API_URL+'/api/trustpilot/54229a4300006400057a8430?callback=trustpilot&jsonp=true';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'trustpilot_widget'));
		}
	}

	componentWillUnmount() {
		var totalId = document.getElementById('available_total'), trustpilot_widget = document.getElementById('trustpilot_widget');
		totalId.parentNode.removeChild(totalId);
		trustpilot_widget.parentNode.removeChild(trustpilot_widget);
	}


	render() {
		return (
			<div>

				<Helmet
					title="Freelance Writing Jobs in India. Online Writing Jobs - India.UvoCorp.com"
					meta={[
						{ name: "description", content: "Freelance writing jobs online in India. Apply for a job online with India.UvoCorp.com Registration is free." },

						{ property: 'og:title', content: "Freelance Writing Jobs in India. Online Writing Jobs - India.UvoCorp.com" },
						{ property: 'og:description', content: "Freelance writing jobs online in India. Apply for a job online with India.UvoCorp.com Registration is free." },
						{ property: 'og:site_name', content: "India.UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://india.uvocorp.com/" },
						{ rel: 'alternate', href: "https://www.uvocorp.com", hrefLang: "en" },
						{ rel: 'alternate', href: "https://canada.uvocorp.com", hrefLang: "en-ca" },
						{ rel: 'alternate', href: "https://hongkong.uvocorp.com", hrefLang: "en-hk" },
						{ rel: 'alternate', href: "https://india.uvocorp.com", hrefLang: "en-in" },
						{ rel: 'alternate', href: "https://nigeria.uvocorp.com", hrefLang: "en-ng" },
						{ rel: 'alternate', href: "https://pakistan.uvocorp.com", hrefLang: "en-pk" },
						{ rel: 'alternate', href: "https://philippines.uvocorp.com", hrefLang: "en-ph" },

						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-pl" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ro" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-bg" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-md" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ua" },
					]} />


				<div className="home-navigation">
					<div className='header' id="header">
					
						<Navigation />
					
					</div>
				</div>

				<div className="wrapper subdomen">

					<div className="home-header">
						<div className="container">
							<div className="home-header-image">
								<div className="img home-header-img">
									<img id="home-header-img" src={india_character} />
								</div>
							</div>
							<div className="home-header-text">
								<div className="home-header-title">India</div>
								<div className="home-header-subtitle">ACADEMIC WRITING ASSISTANCE AGENCY</div>
								<div className="home-header-button">
									<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Register now</a>
								</div>
							</div>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<a href={`${process.env.GATSBY_API_URL}/prices.html`}>View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
						</div>
					</div>

					<div className="home-benefits home-block-gray">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-block">
						<div className="container">
							<h2>Current projects offered</h2>
							<div className="row">
								<div className="col-sm-6">
									<div className="home-block-img">
										<img src={current_projects} alt="Current projects offered"/>
									</div>
								</div>
								<div className="col-sm-6 home-current-projects-text">
									<p>Average order price: <strong className="home-teal-color">${this.state.average}</strong></p>
									<p>Currently available orders: <strong className="home-teal-color">{this.state.averageOrders}</strong></p>
									<p className="home-current-projects-link"><a href={`${process.env.GATSBY_API_URL}/view_all_orders.html`}>View all orders <svg id="arrow-right" width="22" height="22"><path fill="#f29f22" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a></p>
								</div>
							</div>
							<div className="row subdomen-collapse">
								<div className="col-md-8">

									<Collapse accordion={true} defaultActiveKey="0">
										<Panel header="Freelance Writing Jobs in India">
											<p>Have you ever thought of investing your skills and a bit of free time to <Link to="/make_money_writing_online.html" title="Earn More Money">earn more money</Link> than you get every month? Have you ever been dissatisfied with your income? But it is not easy working two jobs, or studying and working part-time. You would need twice as much time to get from one place to another and that would cut the time you could spare for another job. In addition, it is very stressful for your body and mind which, in turn, lowers the physical and intellectual productivity of most people.</p>
										</Panel>
										<Panel header="Is There an Alternative?">
											<p>Of course, there is always an alternative. The solution to your problem is an online job. There are a lot of online writing jobs in India to choose from, that are available on the Internet, although it is advisable to choose a company to work for as carefully as you would while looking for a full-time, or <Link to="/writing_jobs_from_home.html" title="Part-Time Job">part-time job</Link> at any other place. </p>

										</Panel>
										<Panel header="Benefits of Being a Freelancer">
											<p>Freelance writing jobs in India carry a lot of benefits for people who like writing and those who need some extra cash. First of all, you chose the workload yourself so you can easily manage your own time and plan your working schedule beforehand. There is no boss to pressure you with deadlines you won&apos;t be able to meet and the amount of work that you won&apos;t be able to do.</p>
											<p>It is always hard to find a well paid job if you have no experience, especially when you are seeking jobs for writers in India. You do not need experience to apply as a freelance writer, since it is your academic skills that matter. They will be assessed in the registration process, and not the time you have spent working for some company, or companies. Another important thing you need to become a freelance writer is a reliable Internet connection, which is not an issue for most people nowadays. Also, you have the freedom to choose the area, or areas, in which you wish to write. You do not have to write about something that is not familiar to you.</p>
											<p>Another benefit of being a freelance writer is that it gives you more guarantees of a stable income than half of the companies to which you apply as a writer. Moreover, you get paid twice a month through a convenient and reliable paying method that is available, in most locations, worldwide.  A good company makes sure that all your personal information stays confidential and that no third party will get it.</p>

										</Panel>
										<Panel header="A job well-done">
											<p>Get paid to write all sorts of academic papers to help others who are in need of them. You will be able to communicate directly with the customer, if you need to clarify any point relating to the paper, so that you know you are doing the right thing.</p>
											<p>And furthermore, if you are applying for a freelance <Link to="/online_writing_jobs.html" title="Writing Job">writing job</Link> as a part-time way to earn some money - who knows? Maybe you will like it so much that you start working full-time. It&apos;s up to you in what field of study you write, how you manage your time and how much you earn.</p>

										</Panel>
									</Collapse>

								</div>
							</div>
						</div>
					</div>

					<div className="home-block-gray home-block-gray-calltoaction">
						<div className="container">
							<p>Do you want to see the full pricing policy? <a href={`${process.env.GATSBY_API_URL}/prices.html`}>Pricing Policy</a></p>
						</div>
					</div>


					<div className="home-block">
						<div className="container">
							<h2>What our writers say</h2>

							<Slider />

							<div className="trast">
								<div className="trast-avatar">
									<img src={review_logo} alt="avatar for trustpilot.com"/>
								</div>
								<div className="trast-info">
									<div className="trast-info-rating-stars">
										<ul className="rating">
											{this.state.trustScore < 1?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 2?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 3?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 4?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{this.state.trustScore < 5?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
										</ul>
									</div>
									<div className="trast-info-rating">
										{this.state.ratingWord} {this.state.trustScore} <span className="trast-info-gray">from 0 - 5</span>
									</div>
									<div className="trast-info-based">
										<span className="trast-info-gray">based on {this.state.totalNumberOfReviews} reviews</span>
										<img src={trustpilot} width="106" height="13" alt="trustpilot.com"/>
									</div>
									<div className="trast-info-link">
										<a href="https://www.trustpilot.com/review/uvocorp.com" target="_blank">See more reviews <svg id="arrow-right" width="22" height="22"><path fill="#1164c2" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div className="home-registration">
						<div className="container">
							<div className="home-registration-text">
								<div className="home-registration-title">Register now <br />to start earning!</div>
								<div className="home-registration-button">
									<a href={`${process.env.GATSBY_API_URL}/register_email.html`}>Start registration</a>
								</div>
							</div>
							<div className="home-registration-image">
								<div className="img home-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/index.js